<template>
  <dashboard-layout>
    <div class="tw-mx-auto tw-w-full tw-max-w-[1400px]">
      <div id="main-content">
        <slot />
      </div>
    </div>
  </dashboard-layout>
</template>

<script setup lang="ts">
import DashboardLayout from "layouts/components/DashboardLayout.vue";
</script>
